import React from "react";
import {
  Icon,
  TextInput,
  Tooltip,
  useCopyToClipboard,
} from "@zapier/design-system";
import styles from "./CopyToClipboardTextarea.module.css";

type Props = {
  value: string;
  rows?: number;
};
function CopyToClipboardTextarea({ value, rows = 20 }: Props) {
  const [didCopy, handleCopyText] = useCopyToClipboard(value);
  const onClickCopy = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    handleCopyText();
  };
  const renderCopyButton = ({ iconSize }: { iconSize: number }) => {
    const ariaLabel = didCopy
      ? `"Value copied to the clipboard`
      : `Copy value to the clipboard`;
    return (
      <button
        aria-label={ariaLabel}
        color="primary"
        className={styles.copyButton}
        onClick={onClickCopy}
        type="button"
      >
        <Icon isBlock={true} name="actionCopy" size={iconSize} />
        <div className={styles.copyToClipboardTooltip} data-hidden={!didCopy}>
          <Tooltip aria-hidden={true} position="west">
            Copied to clipboard!
          </Tooltip>
        </div>
      </button>
    );
  };

  return (
    <div className={styles.copyToClipboardTextInputWrapper}>
      <TextInput
        value={value}
        isReadonly={true}
        isMultiline={true}
        rows={rows}
      />
      {renderCopyButton({ iconSize: 24 })}
    </div>
  );
}

export default CopyToClipboardTextarea;
